<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper sales-list">
    <div class="content">
      <div v-if="isLoading" class="page-loading-overlay">
        <div class="spinner-border text-primary dashboard-spinner" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>List des Devis</h4>
            <h6>Gérer vos Devis</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf" @click.prevent="exportPDF">
              <img src="@/assets/img/icons/pdf.svg" alt="img" />
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" @click.prevent="exportCSV">
              <img src="@/assets/img/icons/excel.svg" alt="img" />
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print" @click.prevent="printTable">
              <vue-feather type="printer" class="printer"></vue-feather>
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh" @click.prevent="refreshList">
              <vue-feather type="rotate-ccw" class="rotate-ccw"></vue-feather>
            </a>
          </li>
          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
              @click="toggleCollapse">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a href="javascript:void(0);" class="btn btn-added" data-bs-toggle="modal"
            data-bs-target="#add-sales-new"><vue-feather type="plus-circle" class="me-2"></vue-feather> Ajouter
            un nouveau Devis</a>
        </div>
      </div>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" v-model="searchQuery"
                  @input="applyFilters" @keyup.enter="applyFilters" />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"><i data-feather="search"
                    class="feather-search"></i></a>
              </div>
            </div>
            <!-- Client Filter -->
            <div class="col-lg-3 col-sm-6 col-12">
              <div class="search-input">
                <i data-feather="user" class="info-img"></i>
                <vue-select :options="clientData" placeholder="Choisir un client" v-model="filterClient"
                  @change="applyFilters" />

              </div>
            </div>

            <!-- Statut Filter -->
            <div class="col-lg-2 col-sm-6 col-12">
              <div class="search-input">
                <i data-feather="stop-circle" class="info-img"></i>
                <vue-select :options="[...new Set(data.map(d => d.statut))]" placeholder="Choisir un statut"
                  v-model="filterStatus" @change="applyFilters" />
              </div>
            </div>

            <!-- Date Filter -->
            <div class="col-lg-3 col-sm-6 col-12">
              <div class="search-input">
                <i data-feather="calendar" class="info-img"></i>
                <input type="date" v-model="filterDate" class="form-control" @change="applyFilters" />
              </div>
            </div>

          </div>
          <!-- /Filter -->
          <div class="card" id="filter_inputs" :style="{ display: filter ? 'block' : 'none' }">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="user" class="info-img"></i>
                    <vue-select :options="Macbook" id="macbook" placeholder="Choose Customer Name" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="stop-circle" class="info-img"></i>
                    <vue-select :options="Fruits" id="fruits" placeholder="Choose Status" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="file-text" class="info-img"></i>
                    <input type="text" placeholder="Enter Reference" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="stop-circle" class="info-img"></i>
                    <vue-select :options="Computers" id="computer" placeholder="Choose Payment Status" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <a class="btn btn-filters ms-auto">
                      <i data-feather="search" class="feather-search"></i>
                      Recherche
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive">
            <a-table :columns="columns" :data-source="filteredData" :row-selection="{}">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Status'">
                  <div>
                    <span :class="record.Status_class">{{
                      record.Status
                    }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'Payment_Status'">
                  <div>
                    <span :class="record.Payment_Class">{{
                      record.Payment_Status
                    }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <!-- <a
                        class="me-2 edit-icon p-2"
                        data-bs-toggle="modal"
                        data-bs-target="#sales-details-new"
                      >
                        <i data-feather="eye" class="feather-eye"></i>
                      </a> -->
                      <a class="me-2 p-2" href="javascript:void(0);" data-bs-toggle="modal"
                        data-bs-target="#edit-sales-new" @click="openEditModal(record)">
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a class="me-2 p-2" href="javascript:void(0);" @click="handlePdf(record)"><vue-feather
                          type="download" class="info-img"></vue-feather></a>
                      <a class="confirm-text p-2" @click="showConfirmation(record.id, record.commande_id)"
                        href="javascript:void(0);">
                        <vue-feather type="trash-2" class="trash-2"></vue-feather>
                      </a>
                    </div>
                  </td>
                  <!-- <div class="text-center">
                    <a
                      class="action-set"
                      href="javascript:void(0);"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul class="dropdown-menu sales-list-icon">
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#sales-details-new"
                          ><vue-feather
                            type="eye"
                            class="info-img"
                          ></vue-feather
                          >Sale Detail</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-sales-new"
                          ><vue-feather
                            type="edit"
                            class="info-img"
                          ></vue-feather
                          >Edit Sale</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#showpayment"
                          ><vue-feather
                            type="dollar-sign"
                            class="info-img"
                          ></vue-feather
                          >Show Payments</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#createpayment"
                          ><vue-feather
                            type="plus-circle"
                            class="info-img"
                          ></vue-feather
                          >Create Payment</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          ><vue-feather
                            type="download"
                            class="info-img"
                          ></vue-feather
                          >Download pdf</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item confirm-text mb-0"
                          ><vue-feather
                            type="trash-2"
                            class="info-img"
                          ></vue-feather
                          >Delete Sale</a
                        >
                      </li>
                    </ul>
                  </div> -->
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>

  <sales-list-modal @devis-added="onDevisAdded" @edit-added="onDevisUpdated" :data="selectedDevis"></sales-list-modal>
</template>

<script>
import { getDevisData, deleteDevis } from "@/services/devisService";
import { getClientsData } from "@/services/clientsService";
import { generateCommandPdf } from "@/services/pdfService";
import { getCompanyData, getCompanyLogoDataUrl } from "@/services/companyService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import { toast } from "vue3-toastify";
import { ref } from "vue";
import Swal from "sweetalert2";

const columns = [
  {
    sorter: true,
  },
  {
    title: "Référence du devis",
    dataIndex: "numero_devis",
    sorter: {
      compare: (a, b) => String(a?.numero_devis || "").localeCompare(String(b?.numero_devis || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Nom Client",
    dataIndex: "client_nom",
    sorter: {
      compare: (a, b) => String(a?.client_nom || "").localeCompare(String(b?.client_nom || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Date",
    dataIndex: "CreatedOn",
    sorter: {
      compare: (a, b) => {
        const toTs = (v) => (v ? new Date(v).getTime() || 0 : 0);
        const va = toTs(a?.date_creation || a?.CreatedOn);
        const vb = toTs(b?.date_creation || b?.CreatedOn);
        return va - vb;
      },
    },
  },
  {
    title: "Statut",
    dataIndex: "statut",
    key: "Status",
    sorter: {
      compare: (a, b) => String(a?.statut || "").localeCompare(String(b?.statut || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Totale du Commande",
    dataIndex: "montant_total",
    sorter: {
      compare: (a, b) => (Number(a?.montant_total) || 0) - (Number(b?.montant_total) || 0),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const data = [];
const clientData = [];
const clientIds = [];
const clients = [];
const productsData = [];
const productsIds = [];
const imagePreview = ref(null);
const imagePreview1 = ref(null);

export default {
  data() {
    return {
      searchQuery: "",
      filterClient: "",    // Selected client
      filterStatus: "",    // Selected status
      filterDate: "",      // Selected date
      filteredData: [],
      filter: false,
      Sortdate: ["Sort by Date", "07 09 23", "21 09 23"],
      Macbook: ["Choose Customer Name", "Macbook pro", "Orange"],
      Fruits: ["Choose Status", "Computers", "Fruits"],
      Computers: ["Choose Payment Status", "Computers", "Fruits"],
      columns,
      data,
      selectedDevis: {},
      clientData,
      clientIds,
      company: {},
      clients,
      productsData,
      productsIds,
      imagePreview,
      imagePreview1,
      isLoading: false,
    };
  },
  methods: {
    normalize(str) {
      return String(str ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
    applyFilters() {
      const q = this.normalize(this.searchQuery || '').trim();
      this.filteredData = this.data.filter((r) => {
        const matchesSearch =
          !q ||
          [
            r.numero_devis,
            r.client_nom,
            r.statut,
            r.montant_total,
            r.CreatedOn,
            r.date_creation
          ]
            .filter(Boolean)
            .map(this.normalize)
            .some((v) => v.includes(q));

        const matchesClient = !this.filterClient || this.clientData[this.clientIds.indexOf(r.client_id)] === this.filterClient;

        const matchesStatus = !this.filterStatus || r.statut === this.filterStatus;
        const matchesDate = !this.filterDate || (r.date_creation || r.CreatedOn).startsWith(this.filterDate);

        return matchesSearch && matchesClient && matchesStatus && matchesDate;
      });
    },
    async exportPDF() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;

      let logo = null;
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore */ }

      const drawHeader = () => {
        if (!logo) return;
        const w = 30, h = 12, x = (pageWidth - w) / 2, y = 8;
        try {
          const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(logo, fmt, x, y, w, h);
        } catch (_) { /* ignore */ }
      };
      const drawFooter = () => {
        const c = this.company || {};
        const leftX = margin;
        let y = pageHeight - 22; // leave some space above bottom
        const maxWidth = pageWidth - 2 * margin;
        const lineHeight = 4.2;
        doc.setFontSize(9);
        const write = (text) => {
          if (!text) return;
          const wrapped = doc.splitTextToSize(String(text), maxWidth);
          wrapped.forEach((ln) => { doc.text(ln, leftX, y); y += lineHeight; });
        };

        const line1 = c.name ? String(c.name) : '';
        const line2 = [c.address, c.code_postal].filter(Boolean).join(' | ');
        const line3 = [c.email, c.url].filter(Boolean).join(' | ');
        const taxBits = [];
        if (c.rc) taxBits.push(`RC: ${c.rc}`);
        if (c.if) taxBits.push(`IF: ${c.if}`);
        if (c.ice) taxBits.push(`ICE: ${c.ice}`);
        if (c.tp) taxBits.push(`TP: ${c.tp}`);
        if (c.cnss) taxBits.push(`CNSS: ${c.cnss}`);
        const line4 = taxBits.join(' | ');

        write(line1);
        write(line2);
        write(line3);
        write(line4);
      };

      const body = rows.map((r) => [
        r.numero_devis || `DV-${r.id}`,
        r.client_nom || '-',
        r.date_creation || r.CreatedOn || '-',
        r.statut || '-',
        r.montant_total != null ? Number(r.montant_total).toFixed(2) + ' MAD' : '-',
      ]);

      const startY = headerHeight + 12;
      autoTable(doc, {
        startY,
        head: [['Devis', 'Client', 'Date', 'Statut', 'Total TTC']],
        body,
        headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 28 },
          1: { cellWidth: 60 },
          2: { cellWidth: 30, halign: 'center' },
          3: { cellWidth: 28, halign: 'center' },
          4: { cellWidth: 28, halign: 'right' },
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: () => {
          drawHeader();
          drawFooter();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 6, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: startY, bottom: 26 },
      });

      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `devis_${timestamp}.pdf`;
      doc.save(filename);
    },

    exportCSV() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const headers = ['Devis', 'Client', 'Date', 'Statut', 'Total TTC'];
      const csv = [
        headers.join(','),
        ...rows.map(r => [
          r.numero_devis || `DV-${r.id}`,
          r.client_nom || '',
          r.date_creation || r.CreatedOn || '',
          r.statut || '',
          r.montant_total != null ? Number(r.montant_total) : ''
        ].map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `devis_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    },
    showConfirmation(id_devis, id_commandes) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Devis ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteDevis(id_devis, id_commandes);

            // Update both data and filteredData
            this.data = this.data.filter((item) => item.id !== id_devis);
            this.applyFilters(); // Rebuilds filteredData from the updated data

            this.filteredData = this.filteredData.filter((item) => item.id !== id_devis);

            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Votre devis a été supprimé.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      try {
        const data = await getClientsData();
        data.map((m) => {
          const displayName = (m.nom_societe && m.nom_societe.trim())
            ? m.nom_societe
            : [m.prenom, m.nom].filter(Boolean).join(' ').trim();
          this.clientData.push(displayName);
          this.clients.push(m);
          this.clientIds.push(m.id);
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    findClient(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clients[index];
      }
      return index;
    },
    async getDevisData() {
      this.isLoading = true;
      this.data = [];
      try {
        const data = await getDevisData();
        (Array.isArray(data) ? data : []).map((m) => {
          this.data.push({
            id: m.id,
            statut: m.statut,
            Status: m.statut,
            Status_class: this.devisStatusBadge(m.statut),
            commande_id: m.commande_id,
            numero_devis: m.numero_devis,
            date_creation: m.date_creation,
            valide_jusqua: m.valide_jusqua,
            notes: m.notes,
            commande: m.commande || null,
            societe_id: m.societe_id,
            mode_paiement: m.commande?.mode_paiement || "",
            montant_total: m.commande?.montant_total ?? null,
            montant_taxe: m.commande?.montant_taxe ?? null,
            client_nom: m.client_name || this.getClientName(m.commande?.client_id),
            client_id: m.commande?.client_id ?? null,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
        this.applyFilters();
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      } finally {
        this.isLoading = false;
      }
    },
    async onDevisAdded() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Devis créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      this.getDevisData();
    },
    async onDevisUpdated() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Devis modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      this.getDevisData();
    },

    openEditModal(item) {
      this.selectedDevis = item;
    },

    // Print current devis table (filtered if search is active)
    printTable() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      if (!win) return;
      const html = `
        <html><head><title>Liste des Devis</title>
        <style>
          body{font-family: Arial, Helvetica, sans-serif;}
          table{width:100%;border-collapse:collapse}
          th,td{border:1px solid #ccc;padding:6px;text-align:left;font-size:12px}
          thead th{background:#1E68A3;color:#fff}
        </style>
        </head><body>
        <h3>Liste des Devis</h3>
        <table>
          <thead>
            <tr>
              <th>Devis</th>
              <th>Client</th>
              <th>Date</th>
              <th>Statut</th>
              <th>Total TTC</th>
            </tr>
          </thead>
          <tbody>
            ${rows.map(r => `
              <tr>
                <td>${r.numero_devis || `DV-${r.id}`}</td>
                <td>${r.client_nom || ""}</td>
                <td>${r.date_creation || r.CreatedOn || ""}</td>
                <td>${r.Status || r.statut || ""}</td>
                <td>${r.montant_total != null ? r.montant_total : ""}</td>
              </tr>`).join("")}
          </tbody>
        </table>
        </body></html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch (e) { /* ignore */ } }, 100);
    },

    // Refresh devis list and re-apply filters
    async refreshList() {
      try {
        await this.getDevisData();
        this.applyFilters();
      } catch (e) {
        console.error(e);
      }
    },

    // Map devis statut to badge class
    devisStatusBadge(status) {
      const s = String(status || "").toUpperCase();
      switch (s) {
        case "VALIDÉ":
          return "badges bg-lightgreen"; // green
        case "BROUILLON":
          return "badges bg-lightyellow"; // yellow
        case "ANNULÉ":
          return "badges bg-lightred"; // red
        default:
          return "badges status-badge";
      }
    },

    async getBase64ImageFromUrl(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Error converting image to base64:", error);
        // Return an empty string or handle the error gracefully
        return "";
      }
    },

    async getCompanyData() {
      try {
        const result = await getCompanyData();
        const data = result?.data ?? result;

        this.company = {
          id: data.id,
          name: data.societe_nom,
          address: data.adress,
          email: data.email,
          tel: data.telephone_entreprise,
          telephone_entreprise: data.telephone_entreprise,
          ice: data.ice,
          if: data.identifiant_fiscal,
          rc: data.rc,
          code_postal: data.code_postal,
          telephone_personnel: data.telephone_personnel,
          cin: data.cin,
          tp: data.tp,
          cnss: data.cnss,
          lieu_naissance: data.lieu_naissance,
          nom_complet_arabe: data.nom_complet_arabe,
          nom_complet_francais: data.nom_complet_francais,
          nom_banque: data.nom_banque,
          rib: data.rib,
          code_banque_swift: data.code_banque_swift,
          adresse_siege_social_francais: data.adresse_siege_social_francais,
          webesite: data.webesite,
          url: data.url,
          capital: data.capital,
          logo: data.logo,
          logo_small: data.logo_small,
          created_at: data.created_at,
        };
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },

    async handlePdf(devis) {
      const clientData = this.findClient(devis.client_id);
      // const logoBase64 = await this.getBase64ImageFromUrl(
      //   `${process.env.VUE_APP_URL}storage/${this.company.logo_small}`
      // );
      // Removed unused local variables

      const products = [];

      try {
        const data = await getLignesCommandeDataByCommandeId(devis.commande_id);
        data.forEach((item) => {
          const t = item.item_data && (item.item_data.taux_tva ?? item.item_data.taux_taxe);
          const derived = item.montant_HT ? ((item.montant_TTC / item.montant_HT - 1) * 100) : 0;
          const tax = Number((t ?? derived).toString().replace(',', '.')) || 0;
          products.push({
            nameProduct: item.item_data ? item.item_data.nom : item.nom_libre,
            quantity: item.quantite,
            unit_price: item.prix_unitaire,
            tax,
            PTHT: item.montant_HT,
          });
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de récupérer les lignes de la commande.";
        toast.error(message);
        return;
      }
      const mockCommand = {
        type: "devis",
        nameClient: clientData.nom + " " + clientData.prenom,
        emailClient: clientData.email,
        adressClient: clientData.adresse,
        PhoneClient: clientData.telephone,
        date_created: devis.date_creation,
        Nbdevis: devis.numero_devis,
        client_id: devis.client_id,
        commande_id: devis.commande_id,
        terms_payment: devis.mode_paiement,
        line: products,
        notes: devis.notes,
      };

      let logoSmall = "";
      try {
        logoSmall = await getCompanyLogoDataUrl('logo');
      } catch (_) { /* ignore */ }
      const mockCompanyInfo = {
        logoSmall,
        name: this.company.name,
        address: this.company.address,
        postalCode: this.company.code_postal,
        email: this.company.email,
        website: this.company.url,
        companyLegalName: this.company.name,
        capital: this.company.capital,
        bankInfo: {
          name: this.company.nom_banque,
          rib: this.company.rib,
        },
        socialInfo: {
          address: this.company.adresse_siege_social_francais,
          phone: this.company.telephone_personnel,
          telephone_entreprise: this.company.telephone_entreprise,
          email: this.company.email,
          website: this.company.url,
        },
        taxId: {
          rc: this.company.rc,
          if: this.company.if,
          tp: this.company.tp,
          cnss: this.company.cnss,
          ice: this.company.ice,
        },
      };
      const mockfontData = {
        Roboto: {
          normal:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Regular.ttf",
          bold: "https://www.google.com/search?q=http://example.com/fonts/Roboto-Bold.ttf",
          italics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Italic.ttf",
          bolditalics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-BoldItalic.ttf",
        },
      };
      try {
        generateCommandPdf(mockCommand, mockCompanyInfo, mockfontData);
      } catch (error) {
        console.error("PDF generation failed:", error);
      }

      // exportDocumentPDF(document, this.company, client);
    },
  },
  async mounted() {
    await this.getClientsData();
    await this.getDevisData();
    await this.getCompanyData();
    this.applyFilters();
  },
};
</script>

<style scoped>
.page-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.page-wrapper.sales-list {
  position: relative;
}

.dashboard-spinner {
  width: 48px;
  height: 48px;
}
</style>
